import i18n from '@/utils/i18n'

export default {
  path: '/proxy', // member-en entry all file
  component: () => import(/* webpackChunkName: "about" */ '../views/entry'),
  children: [
    {
      path: '/', // 首页
      name: 'Home',
      meta: {
        title: i18n.t('index3') // '首页'
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/proxy/home')
    },
    {
      path: 'transfer', // 转账
      name: 'transfer',
      meta: {
        title: i18n.t('index7') // '转账'
      },
      component: () =>
        import(
          /* webpackChunkName: "Withdrawal" */
          '../views/proxy/myFund/transfer'
        )
    },
    {
      path: 'wallet', // 钱包
      name: 'wallet',
      meta: {
        title: i18n.t('index8') // '钱包'
      },
      component: () =>
        import(
          /* webpackChunkName: "Withdrawal" */
          '../views/proxy/myFund/wallet'
        )
    },
    {
      path: 'transfer-record',
      name: 'proxyTransferRecord',
      meta: {
        title: i18n.t('my124') //  '账户转账记录'
      },
      component: () => import('../views/proxy/records/transferRecord')
    },
    {
      path: 'agent-deposit', // 代理入金审核
      name: 'proxyAgentDeposit',
      meta: {
        title: i18n.t('proxymoney4') //  '代理入金审核'
      },
      component: () => import('../views/proxy/fundAudit/agentDeposit')
    },
    {
      path: 'agent-withdrawal', // 出金
      name: 'proxyAuditWithdrawal',
      meta: {
        title: i18n.t('public2') //   '代理出金审核'
      },
      component: () => import('../views/proxy/fundAudit/agentWithdrawal')
    },
    {
      path: 'customer-deposit', // 出金
      name: 'proxyCustomerDeposit',
      meta: {
        title: i18n.t('proxymoney77') //    '客户入金审核'
      },
      component: () => import('../views/proxy/fundAudit/customerDeposit')
    },
    {
      path: 'customer-withdrawal', // 出金
      name: 'proxyCustomerWithdrawal',
      meta: {
        title: i18n.t('proxymoney115') // '客户出金审核'
      },
      component: () => import('../views/proxy/fundAudit/customerWithdrawal')
    },
    {
      path: 'promotion-center',
      name: 'proxyPromotionCenter',
      meta: {
        title: i18n.t('promotionCenter')
      },
      component: () => import('../views/user/promotionCenter')
    },
    {
      path: 'invitation-detail',
      name: 'proxyInvitationDetail',
      meta: { title: i18n.t('invitationDetailsV2') },
      component: () => import('../views/user/invitationDetail')
    },
    {
      path: 'commission-details-new',
      name: 'proxyCommissionDetailsNew',
      meta: { title: i18n.t('commissionDetailsV2') },
      component: () => import('../views/user/commissionDetail')
    },
    {
      path: 'perfor-statement', // 我的代理
      name: 'proxyPerforStatement',
      meta: {
        title: i18n.t('public3') //  '代理业绩列表'
      },
      component: () => import('../views/proxy/agentManage/perforStatement.vue')
    },
    {
      path: 'customer-list', // 我的代理
      name: 'proxyCustomerList',
      meta: {
        title: i18n.t('public4') //   '用户明细'
      },
      component: () => import('../views/proxy/customerManage/customerList.vue')
    },
    {
      path: 'customer-transfer-details', // 我的代理
      name: 'proxyCustomerTransferDetails',
      meta: {
        title: i18n.t('proxymoneymanage4') //    '客户交易账户转账明细'
      },
      component: () =>
        import('../views/proxy/fundManage/custTransferDetails.vue')
    },
    {
      path: 'commissionDetail',
      name: 'proxyCommissionDetail',
      meta: {
        title: i18n.t('proxymoneymanage25') // '佣金明细'
      },
      component: () => import('../views/proxy/fundManage/commissionDetail.vue')
    },
    {
      path: 'userBonus',
      name: 'userBonus',
      meta: {
        title: i18n.t('text45') // '用户风险补偿赠金'
      },
      component: () => import('../views/proxy/forexBonus/userBonus')
    },
    {
      path: 'bonusCalculationDetails',
      name: 'bonusCalculationDetails',
      meta: {
        title: i18n.t('text46') // '风险补偿赠金计算明细'
      },
      component: () => import('../views/proxy/forexBonus/bonusCalculationDetails')
    },
    {
      path: 'detailsBonusUsage',
      name: 'detailsBonusUsage',
      meta: {
        title: i18n.t('text47') // '风险补偿赠金使用明细'
      },
      component: () => import('../views/proxy/forexBonus/detailsBonusUsage')
    },
    {
      path: 'userMiningRewards',
      name: 'userMiningRewards',
      meta: {
        title: i18n.t('text99') // '用户每日成长赠金'
      },
      component: () => import('../views/proxy/forexBonus/userMiningRewards')
    },
    {
      path: 'miningRewardDetails',
      name: 'miningRewardDetails',
      meta: {
        title: i18n.t('text100') // '每日成长赠金明细'
      },
      component: () => import('../views/proxy/forexBonus/miningRewardDetails')
    },
    {
      path: 'activationRecordDetails',
      name: 'activationRecordDetails',
      meta: {
        title: i18n.t('text101') // '激活记录明细'
      },
      component: () => import('../views/proxy/forexBonus/activationRecordDetails')
    },
    {
      path: 'bonusDetails',
      name: 'bonusDetails',
      meta: {
        title: i18n.t('text48') // '佣金明细'
      },
      component: () => import('../views/proxy/forexBonus/bonusDetails')
    },
    {
      path: 'opxDrawings',
      name: 'opxDrawings',
      meta: {
        title: i18n.t('text108') // '跑马灯记录'
      },
      component: () => import('../views/proxy/forexBonus/opxDrawings')
    },
    {
      path: 'user-info', // 基础信息
      name: 'proxyInfo',
      meta: {
        title: i18n.t('index20') // '基础信息'
      },
      component: () =>
        import(
          /* webpackChunkName: "UserInfo" */
          '../views/proxy/userInfo/info.vue'
        )
    },
    {
      path: 'notice', // 基础信息
      name: 'proxyNotice',
      meta: {
        title: i18n.t('index35')
      },
      component: () =>
        import(
          /* webpackChunkName: "UserInfo" */
          '../views/public/notice/index.vue'
        )
    }
  ]
}
